/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".brand[_ngcontent-%COMP%]{height:32px}.brand[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{height:100%}"];
export { styles as styles };
